(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("prop-types"), require("@zendeskgarden/react-theming"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["prop-types", "@zendeskgarden/react-theming", "react"], factory);
	else if(typeof exports === 'object')
		exports["GardenSelection"] = factory(require("prop-types"), require("@zendeskgarden/react-theming"), require("react"));
	else
		root["GardenSelection"] = factory(root["PropTypes"], root["GardenTheming"], root["React"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return 